<div class="pr-small">
  <div *ngIf="formStatus === FormStatus.ERROR" class="relative loader" role="alert">
    <fcom-notification class="pr-small-b" [layout]="NotificationLayout.BLOCK" [theme]="NotificationTheme.ALERT">
      {{ 'SERVICE_FORMS.CSServiceForms.retrieveFeedback.chatter.error' | finLocalization }}
    </fcom-notification>
  </div>

  <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader">
    <fin-loader
      role="status"
      [type]="LoaderType.EMBEDDED"
      [title]="'SERVICE_FORMS.CSServiceForms.retrieveFeedback.chatter.loading'"
    ></fin-loader>
  </div>

  <div *ngIf="formStatus !== FormStatus.LOADING" class="relative loader">
    <form class="service-form fill" [formGroup]="reactiveForm" (ngSubmit)="sendMessage()">
      <fcom-text-input
        #message
        class="block pr-xsmall-b"
        [displayMargin]="false"
        [parentForm]="group"
        [controlName]="ChatterFields.MESSAGE"
        [isSensitive]="true"
        [type]="TextInputType.TEXTAREA"
        [translationPrefix]="'SERVICE_FORMS.CSServiceForms.retrieveFeedback.chatter.yourResponse'"
        [characterLimit]="messageLimit"
        [characterCount]="characterCount"
      ></fcom-text-input>

      <div class="flex flex--row flex--wrap">
        <div class="flex-1">
          <fcom-file-uploader
            class="flex-1 mr-medium-b"
            data-testid="chatter-files"
            [allowedFileTypes]="allowedFileTypes"
            [controlName]="ChatterFields.ATTACHMENTS"
            [i18n]="'SERVICE_FORMS.CSServiceForms.fields.fileUploader' | finLocalization"
            [maxAttachments]="maxAttachments"
            [maxSizeInBytes]="maxSizeInBytes"
            [parentForm]="group"
            [uploadService]="uploadFile()"
            #fileUploader
          ></fcom-file-uploader>
        </div>
      </div>

      <fcom-button
        class="block submit-data pr-medium-t"
        data-testid="submit-button"
        [type]="ButtonType.SUBMIT"
        [mode]="ButtonMode.INLINE"
        [disabled]="!reactiveForm.valid"
        [text]="'SERVICE_FORMS.CSServiceForms.retrieveFeedback.chatter.send' | finLocalization"
      ></fcom-button>
    </form>
  </div>
</div>
